import React from 'react';
import { GatsbyImage, IGatsbyImageData, getImage } from 'gatsby-plugin-image';
import './BgBanner.scss';

interface BgBannerProps {
  title: string;
  description: string;
  image: IGatsbyImageData | string;
  cta?: {
    url: string;
    label: string;
    icon?: React.ReactElement;
    external?: boolean;
  };
}
export default function BgBanner({ title, description, image, cta }: BgBannerProps): React.ReactElement {
  return (
    <section className="bg-banner">
      <div className="bg-banner__image-container">
        {typeof image === 'string' ? (
          <img src={image} alt={title} />
        ) : (
          <GatsbyImage alt={title} objectFit="cover" imgStyle={{ objectFit: 'cover' }} image={getImage(image)} />
        )}
      </div>
      <div className="bg-banner__text-container">
        <h3>{title}</h3>
        <p>{description}</p>
        {cta && (
          <a href={cta.url} className="bg-banner__cta" target={cta.external ? '_blank' : null} rel="noreferrer">
            {cta.label} {cta.icon ? cta.icon : null}
          </a>
        )}
      </div>
    </section>
  );
}
